import { useCallback } from "react";
import { CustomRange, CustomRangeValidation } from "../type";

export const minMaxKeys = ["min", "max"] as const;

function useMinmaxValidation() {
  const defaultMinValue: CustomRange<typeof minMaxKeys>["min"]["value"] = 1;
  const defaultMaxValue: CustomRange<typeof minMaxKeys>["max"]["value"] = 2;

  function handleMinValidation(
    value: number | null,
    minmaxValue: CustomRange<typeof minMaxKeys>
  ): CustomRangeValidation {
    if (!value && value !== 0) {
      return {
        validateStatus: "error",
        errorMsg: "Value should not be empty",
      };
    } else if (!minmaxValue.max.value && minmaxValue.max.value !== 0) {
      return {
        validateStatus: "error",
        errorMsg: "'Max' Value should not be empty",
      };
    } else if (
      value > minmaxValue.max.value ||
      value === minmaxValue.max.value
    ) {
      return {
        validateStatus: "error",
        errorMsg: "'Min' Value should be less than Max' value",
      };
    } else {
      return {
        validateStatus: "success",
        errorMsg: null,
      };
    }
  }
  function handleMaxValidation(
    value: number | null,
    minmaxValue: CustomRange<typeof minMaxKeys>
  ): CustomRangeValidation {
    if (!value && value !== 0) {
      return {
        validateStatus: "error",
        errorMsg: "Value should not be empty",
      };
    } else if (!minmaxValue.min.value && minmaxValue.min.value !== 0) {
      return {
        validateStatus: "error",
        errorMsg: "'Min' value should not be empty",
      };
    } else if (
      value < minmaxValue.min.value ||
      value === minmaxValue.min.value
    ) {
      return {
        validateStatus: "error",
        errorMsg: "'Max' value should be greater than 'Min' value",
      };
    } else {
      return {
        validateStatus: "success",
        errorMsg: null,
      };
    }
  }

  const minValidation = useCallback(handleMinValidation, []);
  const maxValidation = useCallback(handleMaxValidation, []);
  return { defaultMinValue, defaultMaxValue, minValidation, maxValidation };
}

export { useMinmaxValidation };
